module.exports = __webpack_public_path__ + "img/multi-campaign-personalization.29a1da10.png";